import { z } from 'zod';
/**
 * Termo dos recursos assistidos (launcher, filtro de domínios, lista de apps). Separado do termo base:
 * aparelhos só em Monitoramento não precisam aceitá-lo.
 */
export const ASSISTED_CONSENT_VERSION = '2026-11-p2-v1';
/** Nome de pacote Android (ex.: com.whatsapp). */
export const PackageNameSchema = z
    .string()
    .max(255)
    .regex(/^[A-Za-z][A-Za-z0-9_]*(\.[A-Za-z][A-Za-z0-9_]*)+$/, 'Nome de pacote inválido');
/** Domínio a bloquear (inclui subdomínios). Normalizado em minúsculas, sem ponto final. */
export const BlockedDomainSchema = z
    .string()
    .trim()
    .toLowerCase()
    .transform((d) => d.replace(/^\*\./, '').replace(/\.$/, ''))
    .pipe(z
    .string()
    .max(253)
    .regex(/^(?=.{1,253}$)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z][a-z0-9-]{0,61}[a-z0-9]$/, 'Domínio inválido'));
/** Hash PBKDF2 da senha de saída do launcher. A senha em claro nunca é armazenada nem enviada ao aparelho. */
export const ExitPasswordHashSchema = z.object({
    algorithm: z.literal('PBKDF2-SHA256'),
    iterations: z.number().int().min(100_000).max(2_000_000),
    saltB64: z.string().min(16).max(64),
    hashB64: z.string().min(40).max(64),
    setAt: z.string(),
});
export const LauncherPolicySchema = z.object({
    enabled: z.boolean(),
    allowedPackages: z.array(PackageNameSchema).max(200),
    exitPassword: ExitPasswordHashSchema.nullable(),
});
export const DomainFilterPolicySchema = z.object({
    enabled: z.boolean(),
    blockedDomains: z.array(BlockedDomainSchema).max(5000),
});
/** Política efetiva entregue ao aparelho (empresa, com sobrescrita por seção do grupo). */
export const DevicePolicySchema = z.object({
    launcher: LauncherPolicySchema,
    domainFilter: DomainFilterPolicySchema,
});
export const EMPTY_POLICY = {
    launcher: { enabled: false, allowedPackages: [], exitPassword: null },
    domainFilter: { enabled: false, blockedDomains: [] },
};
/** Política editada no painel: seções ausentes no grupo herdam da empresa. */
export const PolicyPatchSchema = z.object({
    launcher: LauncherPolicySchema.omit({ exitPassword: true }).optional(),
    domainFilter: DomainFilterPolicySchema.optional(),
});
/** Bloqueia o domínio e todos os subdomínios. Comparação em minúsculas, sem ponto final. */
export function isDomainBlocked(name, blocked) {
    let d = name.toLowerCase().replace(/\.$/, '');
    for (;;) {
        if (blocked.has(d))
            return true;
        const i = d.indexOf('.');
        if (i < 0)
            return false;
        d = d.slice(i + 1);
    }
}
/** App com ícone instalado no aparelho (só nome e pacote). */
export const InstalledAppSchema = z.object({
    packageName: PackageNameSchema,
    label: z.string().max(120),
});
export const AppInventoryRequestSchema = z.object({ apps: z.array(InstalledAppSchema).max(1000) });
/** Contagem diária de bloqueios do filtro (sem domínios). */
export const FilterStatSchema = z.object({
    day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    blocked: z.number().int().min(0).max(10_000_000),
});
//# sourceMappingURL=policy.js.map